export default "__VITE_ASSET__fe05dcbb__"